import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { useContext } from 'react';
import { TRAVEL_AIRPLANE_UP_RIGHT } from '@bwoty-web/ui-kit/icons';

import GlobalContext from '../../context/globalContext';
import { getCloudinaryUrl } from '../../utils/imageUtils';

import './cruisePackageInfoFlight.scss';

const CruisePackageInfoFlight = ({ flight, index }) => {
  const { labels, siteSettings } = useContext(GlobalContext);

  const carrierImageUrl =
    flight.carrierImageUrl !== null
      ? getCloudinaryUrl(
          siteSettings.imageDomain,
          flight.carrierImageUrl,
          25,
          30,
        )
      : '';

  return (
    <div className="iw-cruise-package-flight-info_container">
      <p className="iw-cruise-package-flight-info_heading">{`${
        index === 0 ? labels.outbound : labels.homebound
      } ${flight.departureDate}`}</p>
      <div
        key={flight.bookingEngineKey}
        className="iw-cruise-package-flight-info_subContainer"
      >
        <div className="iw-cruise-package-flight-info__image">
          {carrierImageUrl ? (
            <img alt={flight.carrierName} src={carrierImageUrl} />
          ) : (
            <Icon path={TRAVEL_AIRPLANE_UP_RIGHT} />
          )}
        </div>
        <div className="iw-cruise-package-flight-info__content">
          <p className="iw-cruise-package-flight-info__content-location">
            {`${flight.departureLocation} - ${flight.destinationAirportName}`}
          </p>
          <p className="iw-cruise-package-flight-info__content-datetime">
            {`${flight.departureTime} - ${flight.arrivalTime} `}
          </p>
        </div>
      </div>
    </div>
  );
};

CruisePackageInfoFlight.propTypes = {
  flight: PropTypes.shape({
    arrivalTime: PropTypes.string,
    bookingEngineKey: PropTypes.string,
    carrierImageUrl: PropTypes.string,
    carrierName: PropTypes.string,
    departureDate: PropTypes.string,
    departureLocation: PropTypes.string,
    departureTime: PropTypes.string,
    destinationAirportName: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

export default CruisePackageInfoFlight;
